module.exports = __webpack_public_path__ + "static/media/image_7.4eedc821.jpg";